import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/pro-light-svg-icons/faCircleNotch';
import { LoadingViewProps } from './LoadingViewProps';
import { HorizontalVerticalCenterContainer } from './HorizontalVerticalCenterContainer';
import { TypedMemo } from '../types';
import { withBrandWord } from '../../music24/components/primitives/BrandWord';

const LoadingViewComponent: React.FC<React.PropsWithChildren<LoadingViewProps>> = ({
  label,
  sublabel,
  small = false,
  children,
}) => {
  return (
    <HorizontalVerticalCenterContainer>
      <div className="text-center" role="status" aria-live="polite" aria-busy="true">
        <FontAwesomeIcon icon={faCircleNotch} size={small ? '1x' : '2x'} spin aria-hidden="true" />
        {label && <h4 className="pt-1 text-center ui-text">{withBrandWord(label)}</h4>}
        {sublabel && <span className="pt-1 text-center ui-text">{withBrandWord(sublabel)}</span>}
      </div>
      {children}
    </HorizontalVerticalCenterContainer>
  );
};

export const LoadingView = TypedMemo(LoadingViewComponent);
